import React from 'react';
import ReactHtmlParser from "react-html-parser";

function App() {
  return (
    <div className="App">
		<p>Learn about casino. Stay tuned!</p>
		
		<div style={{width: '970px', height:'250px'}} src="//ad.a-ads.com/1369322?size=970x250">
			{ReactHtmlParser(`<iframe data-aa="1369322" src="//ad.a-ads.com/1369322?size=970x250" scrolling="no" style="width:970px; height:250px; border:0px; padding:0; overflow:hidden" allowtransparency="true"></iframe>`)}
		</div>

		<p>The Objective of Blackjack
		Beat The Dealer. There are some misconceptions about the objective of the game of blackjack but at the simplest level all you are trying to do is beat the dealer.

		How do you beat the dealer?

		By drawing a hand value that is higher than the dealer’s hand value
		By the dealer drawing a hand value that goes over 21.
		By drawing a hand value of 21 on your first two cards, when the dealer does not.

		How do you lose to the dealer? 

		Your hand value exceeds 21.
		The dealers hand has a greater value than yours at the end of the round
		

		It’s also important to note, the other players’ hands at the table have nothing to do with winning the game of Blackjack like they do in Poker games. For all practical purposes, it’s just you against the dealer. Unskilled patrons of the game will try to convince you “it’s a team sport” but don’t be fooled.

		How Do You Find a Hand’s Total Value?
		Blackjack is played with a conventional deck of 52 playing cards and suits don’t matter.

		2 through 10 count at face value, i.e. a 2 counts as two, a 9 counts as nine.
		Face cards (J,Q,K) count as 10.
		Ace can count as a 1 or an 11 depending on which value helps the hand the most.</p>
    </div>
  );
}

export default App;
